import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import {useEvent} from 'Event/EventProvider'
import ErrorAlert from 'lib/ui/alerts/ErrorAlert'
import TextField from 'lib/ui/TextField'
import {api} from 'lib/url'
import Page from 'organization/Event/Page'
import {ObieIntegration} from 'organization/Event/Services/Apps/Obie'
import ObieDescriptionPopover from 'organization/Event/Services/Apps/Obie/ObieDescriptionPopover'
import {useServices} from 'organization/Event/Services/ServicesProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import React, {useState} from 'react'
import {useForm} from 'react-hook-form'
import styled from 'styled-components'
import {ServicesBreadcrumbs} from 'organization/Event/Page/PageBreadcrumbs'

export interface ObieAuth {
  api_token: string
}

export default function LinkPage() {
  const {handleSubmit, register} = useForm()
  const link = useLink()
  const [isLinking, setIsLinking] = useState(false)
  const {add: addIntegration} = useServices()
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const submit = (data: ObieAuth) => {
    if (isLinking) {
      return
    }

    setErrorMessage(null)
    setIsLinking(true)

    link(data)
      .then(addIntegration)
      .catch((e) => {
        setErrorMessage(e.message)
      })
      .finally(() => setIsLinking(false))
  }

  return (
    <ServicesBreadcrumbs page="Obie">
      <Page>
        <Typography variant="h4">Obie</Typography>
        <p>1. In Obie, click on your name in the upper right.</p>
        <p>2. Go to Account Settings, then Service Integrations.</p>
        <p>3. Under API Tokens, click Add token.</p>
        <p>4. Copy the token and paste it below.</p>
        <br />
        <form onSubmit={handleSubmit(submit)}>
          <TextField
            label="API token"
            name="api_token"
            fullWidth
            variant="outlined"
            inputProps={{ref: register, 'aria-label': 'api token'}}
            disabled={isLinking}
          />
          <Box display="flex" alignItems="center">
            <Button
              color="primary"
              variant="contained"
              aria-label="connect"
              type="submit"
              disabled={isLinking}
            >
              Connect
            </Button>
            <ObieDescriptionPopover />
          </Box>
          <StyledErrorAlert>{errorMessage}</StyledErrorAlert>
        </form>
      </Page>
    </ServicesBreadcrumbs>
  )
}

const StyledErrorAlert = styled(ErrorAlert)`
  width: 100%;
  margin-top: ${(props) => props.theme.spacing[4]};
`

function useLink() {
  const {client} = useOrganization()
  const {event} = useEvent()

  return (auth: ObieAuth) => {
    return client.post<ObieIntegration>(
      api(`/events/${event.id}/integrations/obie/link`),
      auth,
    )
  }
}
